module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/room-3e9801b34bd91a4aba2eaefe5f1d1ad2.webp";